import { useAppRouter as useRouter } from '@/shared/hooks/useAppRouter'

import { StarIcon } from '@hugeicons/react'
import _ from 'lodash'

import { useRecord } from '@/shared/hooks'
import { publicApi } from '@/shared/lib/api'

import { DigitalProductLandingPagesRankingUserWidget } from './UserWidget'

export const DigitalProductLandingPagesRanking = () => {
  const router = useRouter()
  const { digitalProductId } = router.query
  const { record: dashboard, isLoading } = useRecord({
    r: `/public/digital_products/${digitalProductId}/insights/dashboard`,
    forceIdPresence: false,
    options: {
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: 60000,
      refetchIntervalInBackground: 180000,
      retry: true
    },
    queryFn: async ({ queryKey }) => {
      const { data } = await publicApi.get(queryKey[0])

      return data
    }
  })
  const ranking = [...(dashboard?.points_ranking || [])]
  let sortedRanking = _.orderBy(ranking, 'rank', ['asc'])
  let top3Ranking = []
  let topRanking = []

  sortedRanking.forEach(ranking => {
    ranking.id = ranking?.user_progress?.user?.id || ranking.rank

    if (ranking.rank <= 3 && top3Ranking.length < 3) top3Ranking.push(ranking)
    else topRanking.push(ranking)
  })

  if (isLoading) return null
  return (
    <div className="container h-screen flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center h-full py-10">
        <div className="flex flex-col gap-6 shrink-0 grow-0">
          <div
            className="font-bold text-dark block bg-white px-8 pt-7 rounded text-center flex items-center gap-4 justify-center w-full"
            style={{ paddingBottom: 100 }}
          >
            <StarIcon className="text-info" variant="duotone" size={30} />
            <span className="text-2xl font-bold">Ranking de Experiência</span>
          </div>
          <div
            className="flex gap-2 lg:gap-6 items-start justify-around mb-6 mx-10"
            style={{ marginTop: -110 }}
          >
            {top3Ranking.map((ranking, index) => (
              <DigitalProductLandingPagesRankingUserWidget
                key={ranking?.id}
                {...ranking}
                className={`${ranking.rank != 1 ? 'mt-2' : ''} ${`order-${
                  ranking.rank == 1 ? 2 : ranking.rank == 2 ? 1 : 3
                }`}`}
              />
            ))}
            {top3Ranking.length == 2 && (
              <div className="w-full p-2 relative max-w-[125px] mt-2 order-3"></div>
            )}
          </div>
        </div>
        {topRanking && topRanking.length > 0 && (
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 max-w-[900px] shrink overflow-hidden">
            {topRanking.slice(0, 10).map(ranking => (
              <div key={ranking?.id}>
                <DigitalProductLandingPagesRankingUserWidget
                  {...ranking}
                  size="sm"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
